import { ServerSubstitutionKeywordsStringAssets } from "../../../../../assets/stringAssets";
import { IObjectSharingRequestTracker } from "../../../../../dataObjects/models/collaboration/ObjectSharingTracker";
import { generateStandardEmailClosingPlainText, generateStandardEmailOpeningPlainText } from "../commonEmailBodyFragments";

/**
 * @function generateEmailBodyPlainTextForObjectSharingRequest Generates the Plain Text body of a notification email indicating that an object (eg, a Channel) has been shared
 * @param {IObjectSharingRequestTracker} objectSharingRequestTracker Object Sharing information with details needed for an email message
 * @returns {string} A string with the Plain Text body of the email message to be sent.
 */
export function generateEmailBodyPlainTextForObjectSharingRequest(objectSharingRequestTracker: IObjectSharingRequestTracker): string {

  // *** Compose the email Body in Plain Text format ***
  // salutation/greetings to the recipient
  let emailBodyPlainText = generateStandardEmailOpeningPlainText(objectSharingRequestTracker.recipientName);

  // inform that an object has been shared with you
  emailBodyPlainText += `${objectSharingRequestTracker.requestorName} has shared the ${objectSharingRequestTracker.sharingObjectName} ${objectSharingRequestTracker.sharingObjectType} with you in ${ServerSubstitutionKeywordsStringAssets.ProjectName}! \n\n`;
  // if it was detected that the recipient does not currently have a user account, add message about registering
  if (!objectSharingRequestTracker.recipientUserId || (objectSharingRequestTracker.recipientUserId === 'undefined') || objectSharingRequestTracker.recipientUserId.trim().length === 0) {
    emailBodyPlainText += `If you are not an existing user of ${ServerSubstitutionKeywordsStringAssets.ProjectName}, you may create a new user account at the 
      ${ServerSubstitutionKeywordsStringAssets.AppUrl}/createNewAccount, the ${ServerSubstitutionKeywordsStringAssets.ProjectName} application user registration page.\n\n`;
  } else {
    // inform existing users where to login
    emailBodyPlainText += `Existing users of ${ServerSubstitutionKeywordsStringAssets.ProjectName} may login at ${ServerSubstitutionKeywordsStringAssets.AppUrl}.\n\n`;
  }

  // enjoy sharing ...
  emailBodyPlainText += `Enjoy the ${objectSharingRequestTracker.sharingObjectName} ${objectSharingRequestTracker.sharingObjectType} that has been shared with you by ${objectSharingRequestTracker.requestorName}!\n\n`;

  emailBodyPlainText += generateStandardEmailClosingPlainText();

  // return the email content
  return emailBodyPlainText;
}
